<app-header></app-header>
<div class="content-wrapper my-5 p-t-25 dis-flex">
  <div *ngIf="isSidebarOpen" class="sidebar">
    <app-sidebar
      (dropdownSelection)="myTaskSelection($event)"
      [teamMembersLists]="teamMembersLists"
      [isWpDashboard]="true"
      (close)="toggleSidebar()"
      (wpDashboardTeamMembers)="wpDashboardTeamMembers($event)"
    ></app-sidebar>
  </div>
  <div class="main-content p-t-20">
    <div class="container-fluid">
      <div>
        <p-breadcrumb
          class="max-w-full"
          [model]="breadCrumbItems"
          [home]="breadCrumbHome"
        >
          <ng-template pTemplate="item" let-item>
            <p class="b2 m-b-0">{{ item.label }}</p>
          </ng-template>
          <ng-template pTemplate="separator"> / </ng-template>
        </p-breadcrumb>
      </div>
      <div class="dis-flex flex-m flex-sb">
        <h1 class="font-medium m-b-0">Dashboard</h1>
        <div class="dis-flex">
          <button class="btn outline b2 wd-120px" (click)="toggleSidebar()">
            <ng-icon
              name="hugeFilter"
              size="16"
              class="m-r-5 lh-1-0 text-70"
            ></ng-icon>
            Filters {{ filterCount > 0 ? "(" + filterCount + ")" : "" }}
          </button>
        </div>
      </div>

      <div class="body-card pos-relative">
        <div  class="w-full">
          <p-scrollPanel>
            <div class="m-t-6" *ngIf="!isGraphLoading; else loadingData">
              <div class="w-full">
                <div class="float-l wd-22">
                  <app-total-count-card
                    title="Total Work Packages"
                    [total]="dashboardCount?.total"
                  ></app-total-count-card>
                </div>
                <div class="dis-flex flex-w float-l wd-78">
                  <div
                    *ngFor="
                      let status of statusCard
                        | wpDashboardCount : dashboardCount
                    "
                    class="wd-20"
                  >
                    <app-status-card
                      *ngIf="status"
                      [title]="status.title"
                      [count]="status.count"
                      [iconName]="status.iconName"
                      [iconColor]="status.iconColor"
                      [iconBoxColor]="status.iconBoxColor"
                      class="dis-flex"
                    ></app-status-card>
                  </div>
                </div>
              </div>

              <div class="dis-flex w-full graph-container">
                <div class="graph-card">
                  <h3
                    class="graph-title text-90 font-medium border-bottom-20 p-b-8" ngbTooltip="Medium Term Outcomes"
                  >
                    MTO (Theme Wise)
                  </h3>
                  <div class="graph-wrapper">
                    <div *ngIf="!QThemeWise">Loading status wise data...</div>
                    <app-bar
                      *ngIf="QThemeWise"
                      class="w-full"
                      [barType]="true"
                      [xAxisLabels]="themeValues"
                      [themeVal]="xAxisLabels"
                      [colors]="barColors"
                    ></app-bar>
                  </div>
                </div>
                <div class="graph-card">
                  <div class="">
                    <p-tabView
                      (onChange)="tabChange($event)"
                      [(activeIndex)]="tabIndex"
                    >
                      <p-tabPanel header="Brands"></p-tabPanel>
                      <p-tabPanel header="Therapy Area"></p-tabPanel>
                      <p-tabPanel header="Indication"></p-tabPanel>
                      <div class="graph-wrapper">
                        <app-doughnut
                          class="m-t-23"
                          name="BrandChart"
                          [colors]="colors"
                          [customLabels]="customLabels"
                          [series]="seriesData"
                        ></app-doughnut>
                      </div>
                    </p-tabView>
                  </div>
                </div>
              </div>

              <div class="dis-flex wd-50 graph-container">
                <div class="graph-card">
                  <h3
                    class="graph-title text-90 font-medium border-bottom-20 p-b-8"
                  >
                    Area of Impact
                  </h3>
                  <div class="graph-wrapper">
                    <div *ngIf="QimpactGraph">Loading status wise data...</div>
                    <app-polar
                      *ngIf="!QimpactGraph"
                      class="m-t-23"
                      [customLabels]="['Affiliate', 'Cluster', 'Global']"
                      [customSeries]="impactSeriesData"
                      [customColors]="impactColors"
                    ></app-polar>
                  </div>
                </div>
              </div>
            </div>
          </p-scrollPanel>
        </div>
        <ng-template #loadingData>
          <app-shimmer-list [count]="5"></app-shimmer-list>
        </ng-template>
      </div>
    </div>
  </div>
</div>
